var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0073c2",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.2909,0.35726) scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358,1166c-111,-155 -211,-323 -250,-421c-61,-151 -39,-289 61,-398c40,-43 131,-99 182,-110c24,-6 26,-11 36,-108c6,-64 15,-104 23,-109c23,-14 178,-23 269,-16c172,13 284,58 377,150c92,92 139,211 151,380c6,89 -4,244 -17,265c-14,23 -188,36 -299,23c-53,-7 -105,-14 -117,-18c-18,-5 -26,5 -58,65c-39,76 -143,235 -224,344l-50,69zM518,1048c97,-144 168,-271 154,-276c-6,-2 -37,-20 -70,-41c-64,-42 -107,-88 -146,-161c-28,-52 -66,-185 -66,-232c0,-34 -17,-36 -75,-8c-97,47 -166,153 -166,257c-1,66 21,128 83,243c47,88 199,320 209,320c4,0 38,-46 77,-102zM1130,675c3,-38 3,-85 1,-102l-3,-33h-104h-104v105v106l103,-3l102,-3zM850,632v-107l-95,-95l-95,-95v172c0,196 -8,180 100,214c94,30 90,34 90,-89zM525,200l-65,-65v95c0,151 35,277 98,359l27,36l3,-180l2,-179zM1116,430c-3,-22 -15,-65 -27,-95l-20,-55h-177h-177l95,95l95,95h109h109zM998,199c-8,-23 -116,-80 -189,-98c-71,-18 -136,-24 -249,-22l-44,1l64,65l64,65h179c126,0 178,-3 175,-11z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.51fb0b44840fad80c86a80cb409055a9.svg";
export { ForwardRef as ReactComponent };